export default __webpack_public_path__ + "static/media/DSC_7554.832b8aa0.jpg";